/**
 * Main Oi-Jo API (renters, sellers, vehicles, bookings, admin).
 * Override with REACT_APP_API_BASE_URL (e.g. http://localhost:9000 for local API).
 */
const raw = (process.env.REACT_APP_API_BASE_URL || "https://backend.oi-jo.com").trim();

export const API_BASE_URL = raw.replace(/\/+$/, "");
